import React, { useState } from "react";
import { connect } from "react-redux";
import { GET_CUSTOMIZE_OPTIONS, GET_SINGLE_PRODUCT } from "../apollo";
import { useQuery } from "@apollo/client";

import Image from "./ProductPage/Image";
import AddToCart from "./ProductPage/ATC/AddToCart";
import ProductDetails from "./ProductPage/ATC/ProductDetails";
import PickSize from "./ProductPage/ATC/PickSize/PickSize";
import AddedTC from "./ProductPage/ATC/AddedTC";
import Discount from "./ProductPage/Discount";
import ProductGrid from "./ProductList/ProductGrid";
import PageLoading from "../Pages/PageLoading/PageLoading";
import { RegisterProductView } from "../Pixel";

const Accordion = ({ title, children, isOpen, toggle }) => {
  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={toggle}>
        <span>{title}</span>
        <span className="accordion-control">{isOpen ? "−" : "+"}</span>
      </div>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

const WFSizeGuide = ({ sizeGuideData }) => {
  if (!sizeGuideData || sizeGuideData.length === 0) {
    return <p>No size guide available.</p>;
  }

  const types = [
    { key: "length", label: "Length (cm)" },
    { key: "chest", label: "Chest (cm)" },
    { key: "sleeve", label: "Sleeve (cm)" },
    { key: "waist", label: "Waist (cm)" },
  ];

  const validSizes = sizeGuideData.filter((size) =>
    types.some((type) => size[type.key])
  );

  if (validSizes.length === 0) {
    return <p>No size guide available.</p>;
  }

  const validTypes = types.filter((type) =>
    validSizes.some((size) => size[type.key])
  );

  return (
    <table className="size-guide-table">
      <thead>
        <tr>
          <th>Size</th>
          {validSizes.map((size, index) => (
            <th key={index}>{size.size}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {validTypes.map((type) => (
          <tr key={type.key}>
            <td>{type.label}</td>
            {validSizes.map((size, index) => (
              <td key={index}>{size[type.key] || "—"}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const mapStateToProps = (state) => {
  return {
    title: state.singleProduct.title,
    mainImageSrc: state.singleProduct.mainImageSrc,
    variations: state.singleProduct.variations,
    categories: state.singleProduct.categories,
    mediaType: state.appSettings.mediaType,
  };
};

const Product = (props) => {
  const [isProductDetailsOpen, setProductDetailsOpen] = useState(true);
  const [isSizeFitOpen, setSizeFitOpen] = useState(false);

  var product = {
    id: null,
    mainImageSrc: null,
    galleryImages: [],
    variations: [],
    title: "",
    categories: [],
    description: "",
    relatedProducts: [],
  };

  const { loading, error, data } = useQuery(GET_SINGLE_PRODUCT, {
    variables: {
      slug: props.match.params.path,
      relatedProducts: props.mediaType === "desktop" ? 4 : 5,
    },
  });
  
  const customizeOptions = useQuery(GET_CUSTOMIZE_OPTIONS);

  if (loading) {
    product.title = props.title || "";
    product.mainImageSrc = props.mainImageSrc || null;
    product.variations = props.variations || [];
    product.categories = props.categories || [];
    return <PageLoading />;
  }

  if (error) {
    console.error(error.message);
    return null;
  }

  if (data) {
    var relatedProductsLength = data.relatedProducts.nodes.length;
    var relatedProducts = data.relatedProducts.nodes.filter((item) => {
      return item.databaseId !== data.product.databaseId;
    });
    if (relatedProducts.length === relatedProductsLength) {
      relatedProducts.pop();
    }

    product = {
      id: data.product.databaseId,
      mainImageSrc: data.product.image.mediaItemUrl,
      galleryImages: data.product.galleryImages.nodes,
      variations: data.product.variations.nodes,
      title: data.product.name,
      categories: data.product.productCategories.edges.map((item) => {
        return item.node;
      }),
      description: data.product.description,
      sizeGuide: data.product.wfSizeGuide || [],
      relatedProducts,
    };

    RegisterProductView(data.product.databaseId, product);
    document.title = data.product.name + " | Veronica Virta";
  }

  let expressText = '';
  if (!customizeOptions.loading && customizeOptions.data) {
    expressText = customizeOptions.data.customizePage.wfCustomize.expressText;
  }

  return (
    <div className="single-product">
      <div className="image-description-wrap">
        <Image mainImage={product.mainImageSrc} galleryImages={product.galleryImages}>
          <Discount variations={product.variations} />
        </Image>

        <div className="product-meta-wrap">
          <div className="product-meta-inner">
            <AddToCart productId={product.id}>
              <ProductDetails title={product.title} variations={product.variations || []} categories={product.categories} />
              <PickSize variations={product.variations} categories={product.categories} />
              <AddedTC title={product.title} image={product.mainImageSrc} />
            </AddToCart>

            <span className="pdp-usp-text">{expressText}</span>

            <div className="accordion-wrap">
              <Accordion
                title="Product Details"
                isOpen={isProductDetailsOpen}
                toggle={() => setProductDetailsOpen(!isProductDetailsOpen)}
              >
                <div className="scrollable-content" dangerouslySetInnerHTML={{ __html: product.description }} />
              </Accordion>

              <Accordion title="Size Guide" isOpen={isSizeFitOpen} toggle={() => setSizeFitOpen(!isSizeFitOpen)}>
                <WFSizeGuide sizeGuideData={product.sizeGuide} />
                <p className="size-info">Note: The measurements are in centimeters and correspond to the specific product. For best fit, refer to these values.</p>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <div className="related-products-wrap">
        <span className="title">Check out other products</span>
        <div className="product-list">
          <ProductGrid products={product.relatedProducts} />
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(Product);